import { useQuery } from "@tanstack/react-query";
import { mapSelectOptions } from "../../../utils/map4select";
import { recordsKeys } from "./records.keys";
import { recordsService } from "./records.service";
import { Trademark, TrademarkListPayload } from "./records.types";

export function useTrademarkList({
  filters,
  enabled,
}: {
  filters: TrademarkListPayload;
  enabled?: boolean;
}) {
  return useQuery({
    ...recordsKeys.trademarkList(filters),
    queryFn: () => recordsService.getAllTrademarks(filters),
    select: (response) =>
      mapSelectOptions<Trademark>({
        labelAccessor: "naziv",
        valueAccessor: "id",
        sourceArray: response?.data,
      }),
    retry: false,
    enabled,
  });
}
